import { useCallback } from "react";
import { useSelector } from "src/store";
import { selectCurrentWorkspaceId } from "src/store/app";

import { useGetEventsQuery, usePrefetch } from "./index";
import { GetEventsParams } from "./rtkClient";

type GetEventsQueryOptions = Omit<Parameters<typeof useGetEventsQuery>[1], "selectFromResult">;
function useCurrentWorkspaceEvents(params: GetEventsParams, options?: GetEventsQueryOptions) {
    const workspaceId = useSelector(selectCurrentWorkspaceId);
    const paramsCopy = { ...params };
    if (workspaceId !== null) {
        paramsCopy.workspaceId = workspaceId;
    }

    const optionsCopy = { ...options, skip: false };
    if (options && "skip" in options) {
        optionsCopy.skip = !!options.skip;
    }

    if (!workspaceId) {
        optionsCopy.skip = true;
    }

    return useGetEventsQuery(paramsCopy, optionsCopy);
}

function usePrefetchCurrentWorkspaceEvents() {
    const prefetch = usePrefetch("getEvents");
    const workspaceId = useSelector(selectCurrentWorkspaceId);

    return useCallback(
        (params: GetEventsParams) => {
            if (!workspaceId) {
                return;
            }
            prefetch({ ...params, workspaceId });
        },
        [prefetch, workspaceId],
    );
}

export { useCurrentWorkspaceEvents, usePrefetchCurrentWorkspaceEvents };
